import { render, staticRenderFns } from "./SyncLoadingAndMobileTurnOffTabContent.vue?vue&type=template&id=1df992cd&scoped=true&"
import script from "./SyncLoadingAndMobileTurnOffTabContent.vue?vue&type=script&lang=js&"
export * from "./SyncLoadingAndMobileTurnOffTabContent.vue?vue&type=script&lang=js&"
import style0 from "./SyncLoadingAndMobileTurnOffTabContent.vue?vue&type=style&index=0&id=1df992cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df992cd",
  null
  
)

export default component.exports